module.exports = __webpack_public_path__ + "img/75fc907d2c98b78e63e4e78445581cce.png";